<ngx-charts-pie-chart
  [view]="[width, height]"
  [scheme]="colors"
  [results]="result"
  [doughnut]="true"
  [arcWidth]="0.45"
  [margins]="[0, 0, 0, 0]"
>
  <ng-template #tooltipTemplate let-model="model">
    <div class="ngx-tooltip">{{ model.value }}% {{ model.name | translate }}</div>
  </ng-template>
</ngx-charts-pie-chart>
